// @vendors
import React from "react";
import { Outlet } from "react-router-dom";

// @components
import { HeaderDashboard } from "../header/HeaderDashboard";
import { SidebarDashboard } from "../header/SidebarDashboard";
import { useThemeStore } from "../../store/useThemeStore";

export const DashboardLayout: React.FC = () => {
  const { isDarkMode } = useThemeStore();

  return (
    <div className={`flex lg:flex-row flex-col lg:h-screen h-auto ${isDarkMode ? "dark" : ""} overflow-hidden dark:bg-[#282828]`}>
      <SidebarDashboard />
      <div className="flex-1 overflow-hidden pb-[60px]">
        <HeaderDashboard />
        <main className="flex-1 h-full overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-[#282828] p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
